import React from 'react';
import ReactDOM from 'react-dom';

import './Style.css';

import ModalAcoesGrupo from './ModalAcoesGrupo';
import ModalAvaliacao from './ModalAvaliacao';
import ModalDemerito from './ModalDemerito';
import ModalVariacoes from './ModalVariacoes';
import PainelFiltros from './PainelFiltros';
import Sumario from './Sumario';
import TabelaBases from './TabelaBases';

class AtualizacaoPeriodica extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            cityPeriod: props.cityPeriod || null,
            bases: props.bases || {},
            bairros: props.bairros || [],
            padroes: props.padroes || [],
            operadores: props.operadores || [],
            countBuildingsFromPeriod: props.countBuildingsFromPeriod || {},
            acoesGrupo: props.acoesGrupo || [],
            bulkActionsUrl: props.bulkActionsUrl || '',

            filters: {
                name: [],
                type: null,
                status: null,
                pattern: null,
                neighborhood: null,
                previsao_lancamento: null,
                data_cadastro_inicial: null,
                data_cadastro_final: null,
                incorporator: [],
                status_update: null,
                user: [],
                role: null,
            },

            selectedBases: [],
            bulkActionsModalOpen: false,
            bulkActionsLoading: false,
            modalDemeritoOpen: false,
            variationsModalOpen: false,
            variationsLoading: false,
            variations: null,
            modalAvaliacaoOpen: false,
            selectedBaseToValidate: null,
            avaliacaoLoading: false,
        };
    }

    handleFilterChange = (field, value) => {
        this.setState((previousState) => ({
            filters: {
                ...previousState.filters,
                [field]: value,
            },
        }));
    };

    handleFilter = async (event) => {
        if (event) {
            event.preventDefault();
        }

        await this.fetchBases();
    };

    handleClearFilters = () => {
        const emptyFilters = {
            name: [],
            type: null,
            status: null,
            pattern: null,
            neighborhood: null,
            previsao_lancamento: null,
            data_cadastro_inicial: null,
            data_cadastro_final: null,
            incorporator: [],
            status_update: null,
            user: [],
            role: null,
        };

        this.setState(
            {
                filters: emptyFilters,
                selectedBases: [],
            },
            async () => {
                await this.fetchBases();
            }
        );
    };

    fetchBases = async (page = 1) => {
        const {
            cityPeriod,
        } = this.state;

        if (!cityPeriod?.id) {
            return;
        }

        this.setState({
            loading: true,
        });

        try {
            const filters = this.prepareFilters();

            const response = await axios.get(
                `/atualizacao-periodica/${cityPeriod.id}/bases`,
                {
                    params: {
                        ...filters,
                        page,
                    },
                }
            );

            this.setState({
                bases: response.data,
                loading: false,
                selectedBases: [],
            });

        } catch (error) {

            console.error('Erro ao buscar empreendimentos:', error);

            this.setState({
                loading: false,
            });
        }
    };

    componentDidMount() {
        // Futuramente:
        // this.buscarDados();
    }

    prepareFilters = () => {
        const {
            filters,
        } = this.state;

        return {
            ...filters,

            name: (filters.name || []).filter((item) => item.id !== 'Selecionar Todos').map((item) => item.id),

            user: (filters.user || []).map((item) => item.id),

            incorporator: (filters.incorporator || []).filter((item) => item.id !== 'Selecionar Todos').map((item) => item.id),

            data_cadastro_inicial:
                filters.data_cadastro_inicial
                    ? this.formatDateForApi(
                        filters.data_cadastro_inicial
                    )
                    : null,

            data_cadastro_final:
                filters.data_cadastro_final
                    ? this.formatDateForApi(
                        filters.data_cadastro_final
                    )
                    : null,
        };
    };

    formatDateForApi = (date) => {
        if (!date) {
            return null;
        }

        const year = date.getFullYear();

        const month = String(
            date.getMonth() + 1
        ).padStart(2, '0');

        const day = String(
            date.getDate()
        ).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    handleToggleBase = (id) => {
        this.setState((previousState) => {
            const selectedBases = previousState.selectedBases;

            if (selectedBases.includes(id)) {
                return {
                    selectedBases: selectedBases.filter(
                        (baseId) => baseId !== id
                    ),
                };
            }

            return {
                selectedBases: [
                    ...selectedBases,
                    id,
                ],
            };
        });
    };

    handleToggleAll = () => {
        const bases = this.state.bases?.data || [];

        const allIds = bases.map((base) => base.id);

        this.setState((previousState) => {
            const allSelected = allIds.every(
                (id) => previousState.selectedBases.includes(id)
            );

            return {
                selectedBases: allSelected
                    ? previousState.selectedBases.filter(
                        (id) => !allIds.includes(id)
                    )
                    : [
                        ...new Set([
                            ...previousState.selectedBases,
                            ...allIds,
                        ]),
                    ],
            };
        });
    };

    handlePageChange = async (page) => {
        await this.fetchBases(page);
    };

    handleBulkActionSubmit = async (form) => {
        const {
            selectedBases,
            bulkActionsUrl,
        } = this.state;

        if (selectedBases.length === 0) {
            alert('Selecione pelo menos uma base.');
            return;
        }

        this.setState({
            bulkActionsLoading: true,
        });

        try {
            const response = await axios.post(
                bulkActionsUrl,
                {
                    bases: selectedBases,
                    acao: form.acao,
                    user: form.user || null,
                    period: form.period || null,
                    password: form.password || null,
                }
            );

            this.setState({
                bulkActionsModalOpen: false,
                bulkActionsLoading: false,
                selectedBases: [],
            });

            alert('Ação em grupo realizada com sucesso');

            // Atualiza a tabela depois da ação
            await this.fetchBases();

        } catch (error) {
            console.error('Erro ao executar ação em grupo:', error);

            this.setState({
                bulkActionsLoading: false,
            });
        }
    };

    handleAvaliacaoSubmit = async (form) => {
        this.setState({
            avaliacaoLoading: true,
        });

        const {
            cityPeriod,
        } = this.state;

        try {
            await axios.post(
                `/salvar-avaliacao`,
                {
                    base_id: form.base_id,
                    city_period_id: cityPeriod.id,
                    motivos: (form.motivos || []).map((item) => item.id),
                    comentario: form.comentario || null,
                }
            );

            alert('Avaliação adicionada com sucesso');

            this.setState({
                avaliacaoLoading: false,
                modalAvaliacaoOpen: false,
                selectedBaseToValidate: null,
            });

            await this.fetchBases();

        } catch (error) {
            console.error('Erro ao adicionar avaliação:', error);

            this.setState({
                avaliacaoLoading: false,
            });
        }
    };

    showModalDemerito = async () => {
        this.setState({
            modalDemeritoOpen: true,
        });
    };

    closeModalDemerito = () => {
        this.setState({
            modalDemeritoOpen: false,
        });
    };

    showVariationsModal = async () => {
        const { cityPeriod } = this.state;

        if (!cityPeriod?.id) {
            return;
        }

        this.setState({
            variationsModalOpen: true,
            variationsLoading: true,
            variations: null,
        });

        try {
            const response = await axios.get(
                `/show-variations/${cityPeriod.id}`
            );

            this.setState({
                variations: response.data,
                variationsLoading: false,
            });
        } catch (error) {
            console.error('Erro ao buscar variações:', error);

            this.setState({
                variationsLoading: false,
                variations: null,
            });
        }
    };

    closeVariationsModal = () => {
        this.setState({
            variationsModalOpen: false,
        });
    };

    showModalAvaliacao = (id) => {
        this.setState({
            modalAvaliacaoOpen: true,
            selectedBaseToValidate: id
        });
    };

    closeModalAvaliacao = () => {
        this.setState({
            modalAvaliacaoOpen: false,
            selectedBaseToValidate: null
        });
    };

    showBulkActionsModal = () => {
        const { selectedBases } = this.state;

        if (selectedBases.length === 0) {
            alert('Selecione pelo menos uma base.');
            return;
        }

        this.setState({
            bulkActionsModalOpen: true,
        });
    };

    closeBulkActionsModal = () => {
        if (this.state.bulkActionsLoading) {
            return;
        }

        this.setState({
            bulkActionsModalOpen: false,
        });
    };

    render() {
        const {
            loading,
            filters,
            cityPeriod,
            bases,
            bairros,
            padroes,
            operadores,
            selectedBases,
            bulkActionsModalOpen,
            bulkActionsLoading,
            modalDemeritoOpen,
            variationsModalOpen,
            variationsLoading,
            variations,
            modalAvaliacaoOpen,
            selectedBaseToValidate,
            avaliacaoLoading,
            countBuildingsFromPeriod,
        } = this.state;

        return (
            <div>
                <div className="card-updated">
                    <div className="card-body summary">
                        <Sumario
                            cityPeriod={cityPeriod}
                            countBuildingsFromPeriod={countBuildingsFromPeriod}
                            onShowModalDemerito={this.showModalDemerito}
                            onShowVariations={this.showVariationsModal}
                        />

                        <ModalDemerito
                            open={modalDemeritoOpen}
                            onClose={this.closeModalDemerito}
                        />

                        <ModalVariacoes
                            open={variationsModalOpen}
                            loading={variationsLoading}
                            variations={variations}
                            cityPeriod={cityPeriod}
                            onClose={this.closeVariationsModal}
                        />
                    </div>
                </div>
                <div className="card-updated">
                    <div className="card-body form-filtro">
                        <PainelFiltros
                            filters={filters}
                            bairros={bairros}
                            padroes={padroes}
                            cityPeriod={cityPeriod}
                            onFilterChange={this.handleFilterChange}
                            onSubmit={this.handleFilter}
                            onClear={this.handleClearFilters}
                            selectedBases={selectedBases}
                            onShowBulkActions={this.showBulkActionsModal}
                        />

                        <ModalAcoesGrupo
                            open={bulkActionsModalOpen}
                            loading={bulkActionsLoading}
                            selectedBases={selectedBases}
                            acoes={this.state.acoesGrupo}
                            operadores={operadores}
                            onClose={this.closeBulkActionsModal}
                            onSubmit={this.handleBulkActionSubmit}
                        />
                    </div>
                </div>
                <div className="card-updated">
                    <div className="card-body tabela-bases">
                        {loading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>
                            </div>
                        ) : (
                            <TabelaBases
                                bases={bases}
                                selectedBases={selectedBases}
                                onToggleBase={this.handleToggleBase}
                                onToggleAll={this.handleToggleAll}
                                onPageChange={this.handlePageChange}
                                onShowModalAvaliacao={this.showModalAvaliacao}
                            />
                        )}

                        <ModalAvaliacao
                            open={modalAvaliacaoOpen}
                            onClose={this.closeModalAvaliacao}
                            onSelectedBaseToValidate={selectedBaseToValidate}
                            onSubmit={this.handleAvaliacaoSubmit}
                            loading={avaliacaoLoading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('app-atualizacao-periodica');

if (element) {
    const props = {
        bases: JSON.parse(element.dataset.bases || '{}'),
        bairros: JSON.parse(element.dataset.bairros || '[]'),
        cityPeriod: JSON.parse(element.dataset.cityPeriod || '{}'),
        operadores: JSON.parse(element.dataset.operadores || '[]'),
        padroes: JSON.parse(element.dataset.padroes || '[]'),
        acoesGrupo: JSON.parse(element.dataset.acoesGrupo || '[]'),
        countBuildingsFromPeriod: JSON.parse(element.dataset.countBuildingsFromPeriod || '{}'),
        bulkActionsUrl: element.dataset.bulkActionsUrl || '',
    };

    ReactDOM.render(<AtualizacaoPeriodica {...props} />, element);
}
export default AtualizacaoPeriodica;